<template>
  <material-card>
    <v-layout slot="header" px-3>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Kontenery na punkty</div>

        <p>Kontenery na punkty w których klient miał jakiekolwiek punkty</p>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-flex xs12>
        <v-card v-for="(containerPoints, index) in containerPointsList" :key="index" class="ma-2">
          <v-card-text style="position: relative">
            <v-layout row wrap>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <p>
                      <b>Kontener:</b>
                      {{ containerPoints.pointContainer.name }}
                    </p>

                    <p>
                      <b>Punkty: </b>
                      {{ containerPoints.points }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs4 class="text-xs-right">
                <v-layout align-center justify-start row reverse fill-height>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        small
                        icon
                        color="primary"
                        @click="toggleHistory(containerPoints.pointContainer.id)"
                        v-on="on"
                      >
                        <v-icon>mdi-history</v-icon>
                      </v-btn>
                    </template>

                    <span> Historia </span>
                  </v-tooltip>
                </v-layout>
              </v-flex>

              <v-flex v-if="containerPoints.pointContainer.id === containerHistoryId" xs6>
                <v-list two-line>
                  <v-list-tile
                    v-for="(pointHistory, index) in pointHistoryList"
                    :key="'pointHistory_' + index"
                    avatar
                    @click="void 0"
                  >
                    <v-list-tile-avatar>
                      <v-icon :class="pointHistory.points > 0 ? 'green--text' : 'red--text'">
                        {{ pointHistory.points > 0 ? 'mdi-arrow-top-right' : 'mdi-arrow-bottom-right' }}
                      </v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ pointHistory.points }} pkt - Użycie: {{ pointHistory.benefit.name }}
                      </v-list-tile-title>

                      <v-list-tile-sub-title>
                        {{ pointHistory.created | dateFilter }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </material-card>
</template>

<script>
import { dateFilter } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Wyświetlanie zakładki grup klienta
// @group Client-Profile
export default {
  components: { MaterialCard },
  filters: { dateFilter },
  mixins: [notificationsMixin],
  data() {
    return {
      containerHistoryId: null
    };
  },
  computed: mapState({
    containerPointsList: state => state.client.containerPoints.list,
    pointHistoryList: state => state.client.pointHistory.list,
    profileId: state => state.client.data.profile.id
  }),
  methods: {
    // @vuese
    // Funkcja otwierająca historię kontenera
    toggleHistory(pointContainerId) {
      if (this.containerHistoryId === pointContainerId) {
        this.containerHistoryId = null;
        return;
      }
      this.$store
        .dispatch('client/pointHistory/list', {
          pointContainerId,
          profileId: this.profileId
        })
        .then(() => {
          this.containerHistoryId = pointContainerId;
        });
    }
  }
};
</script>
